import { render, staticRenderFns } from "./DialogTextEditor.vue?vue&type=template&id=02ac4d4d"
import script from "./DialogTextEditor.vue?vue&type=script&lang=js"
export * from "./DialogTextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports